import React from 'react';

//interfaces
import { IConditionalTextInput } from '../../interfaces/IConditionalLogicPanel';
import { IconLibrary } from '../../../../interfaces/icon/IconLibrary';

//components
import IconButton from '../../../global/buttons/IconButton';
import BasicTextInput from '../../../global/textInputs/BasicTextInput';
import OnBlurTextInput from '../../../global/textInputs/OnBlurTextInput';



const TextConditionalValue = ({conditions} : {conditions: IConditionalTextInput[]}) => {
    return (
        <div className="toggle-item">
            {conditions.map((condition, index) => (
                    <div key={`${condition.id}-wrapper`} className={`${index !== 0 && "toggle-wrapper"}`}>
                        {condition.label && index === 0 &&   
                            <h2 className="toggle-label">{condition.label}</h2>
                        }

                        <span className="toggle-option">
                            {condition.label && index !== 0 &&  
                                <IconButton 
                                    className="cancel-option-button" 
                                    ariaLabel={''} 
                                    iconName={IconLibrary.CIRCLE_CLOSE} 
                                    onButtonClick={() => condition.removeOption?.()}
                                />
                            }

                            {
                            condition.updateOnBlur 
                            ? <OnBlurTextInput
                                id={condition.id}
                                key={`${condition.id}-input`}
                                labelText={condition.ariaLabel} 
                                placeholderText={condition.placeholderText ?? "Value"} 
                                textString={condition.text} 
                                setTextString={condition.setTextInput}
                                labelIsHidden
                            />
                            :<BasicTextInput
                                id={condition.id}
                                key={`${condition.id}-input`}
                                labelText={condition.ariaLabel} 
                                placeholderText={condition.placeholderText ?? "Value"} 
                                textString={condition.text} 
                                setTextString={condition.setTextInput}
                                labelIsHidden
                            />}
                        </span>
                    </div>
               ))}
        </div>
    )
};

export default TextConditionalValue